export default __webpack_public_path__ + "static/media/womanOnDesk.6f55f301.png";